// Main.js


import React from "react";
import { useEffect, useReducer, useRef, useState } from "react";
import { Appearance, Dimensions, Platform, ScrollView, View, NativeModules } from "react-native";
// import { Feather } from "@react-native-vector-icons/feather";    // https://feathericons.com/?query=
import { stateReducer } from "components/helpers/stateReducer";
import { DisplayStatus, ScreenLoading } from "components/Partials/Status";
import rootView from "react-native-root-view";
import Header from "./Partials/Header";
// import Footer from "./Partials/Footer";
import appviews from "./helpers/appviews";
import auth from "./helpers/auth";
import AlertModal, { triggerAlert } from "./Partials/AlertModal";
import theme from "./helpers/themes";
import { format as format, formatDistanceToNowStrict, addDays, isDate } from "date-fns";  //https://date-fns.org/docs/Getting-Started
const { StatusBarManager } = NativeModules;
const statusBarHeight = (StatusBarManager?.HEIGHT || 0);

// Global Main application namespace libraries
window.main = window.main || {};
window.main.platform_os = Platform.OS;
window.main.scrollPosition = { x:0, y:0 };
window.main.lib = window.main.lib || {};

window.main.onClickStack = window.main.onClickStack || {};
window.main.addOnClick = (key, func) => {
  if (!(key in window.main.onClickStack)) {
    window.main.onClickStack[key] = func;
  }
};
window.main.removeOnClick = (key) => {
  if (key in window.main.onClickStack) {
    delete window.main.onClickStack[key];
  }
};

window.main.onScrollStack = window.main.onScrollStack || {};
window.main.addOnScroll = (key, func) => {
  if (!(key in window.main.onScrollStack)) {
    window.main.onScrollStack[key] = func;
  }
};
window.main.removeOnScroll = (key) => {
  if (key in window.main.onScrollStack) {
    delete window.main.onScrollStack[key];
  }
};

window.main.onResizeStack = window.main.onResizeStack || {};
window.main.addOnResize = (key, func) => {
  if (!(key in window.main.onResizeStack)) {
    window.main.onResizeStack[key] = func;
  }
};
window.main.removeOnResize = (key) => {
  if (key in window.main.onResizeStack) {
    delete window.main.onResizeStack[key];
  }
};

window.main.onUnsavedFormStack = window.main.onUnsavedFormStack || {};
window.main.addUnsavedForm = (key, func) => {
  if (!(key in window.main.onUnsavedFormStack)) {
    window.main.onUnsavedFormStack[key] = func;
  }
};
window.main.removeUnsavedForm = (key) => {
  if (key in window.main.onUnsavedFormStack) {
    delete window.main.onUnsavedFormStack[key];
  }
};

// This is causing an error/warning in iOS Simulator. TODO: Figure this out.
// if (window.main.platform_os !== "web") {
//   Feather.loadFont(); // This preps for the rest of the mobile app. Doesn't seem to be needed for Web, Web uses web/app.js web @fontface
// }

///////////////////////////////////////////
///////////////////////////////////////////
// MAIN: //////////////////////////////////
///////////////////////////////////////////
///////////////////////////////////////////
const Main = () => {
  // Load global auth library
  window.main.auth = (window.main.auth||auth(window.main));

  const _web = (window.main.platform_os==="web");
  const _ios = (window.main.platform_os==="ios");
  const _and = (window.main.platform_os==="android");

  const [, _toggleForceRender] = useState(false);
  const _session = useRef(async ()=>{
    const _cookie = await cookie.getAll();
    return (_cookie?.hasOwnProperty("access_token") && !!_cookie.access_token ? JSON.parse(_cookie.access_token) : {});
  });

  const [appState, appSetState] = useReducer(stateReducer,{
    user: {},
    initReady: false,
    isScreenLoading: true,
    statusText: null,
  });

  const _screenStateReducer = (state, newState) => {
    const ret = {...state, ...newState};
    return ret;
  };
  const getDefaultScreenState = () => {
    const viewObj = getDefaultViewObj();
    return {
      currentView: viewObj.viewKey,
      currentViewPath: viewObj.validPath,
      currentViewParams: viewObj.viewParams,
      currentDarkTheme: (Appearance.getColorScheme()==="dark"),
      isLoggedin: false,
      isSessionChecked: false,
    };
  };
  const [_screenState, __setScreenState] = useReducer(
    // Set `reducer` function:
    _screenStateReducer,
    // initial state:
    getDefaultScreenState()
  );

  const screenStateRef = useRef({..._screenState});
  const _setViewState = () => {
    if (!!window.main._screenStateTimeout) {
      window.clearTimeout(window.main._screenStateTimeout);
      window.main._screenStateTimeout = null;
    }
    if (!screenStateRef.current.isSessionChecked) {
      return;  // Prevent state change before session is checked on inital load!
    }
    __setScreenState(screenStateRef.current);
  };
  const _setScreenState = (o) => {
    if (!o || !_screenState.hasOwnProperty(Object.keys(o)[0])) {
      return;
    }
    __setScreenState(o);
  };

  // Global `Main` Library Methods  -- These are cached in `useCallback`.
  window.main.lib.forceRender = ()=>{_toggleForceRender(s=>(!s));};
  window.main.lib.getCurrentView = () => { return _screenState.currentView };
  window.main.lib.setTempCurrentView = (viewPath) => {
    let viewObj = viewPath;  // NOTE: setCurrentView() can pass `viewObj` here to share the processing below.
    let allowLeave = true;  // Default to TRUE for normal workflow.
    // Store the reset of the functionality in a local function to execute after if allowed to continue...
    const continueExec = ()=>{
      // If not `viewObj` then parse the `viewPath`.
      if (!viewObj || typeof(viewObj)!=="object" || !viewObj.hasOwnProperty("viewKey")) {
        viewObj = getDefaultViewObj(viewPath);  // Return object: { viewKey: "string", viewParams: (nested-object key-num pairs) -> { name1: 1, name2: 2 } };
      }
      if (viewObj.validPath != window.main.lib.getCurrentViewPath()) {  // Compares to cached screenStateRef.current.currentView, not actual state...
        // try {
        //   // Trigger analytics of navigation here:
        //   (!!_cogentInit.current && cogent.track({path:viewObj.validPath},{source:"setTempCurrentView",platform:window.main.platform_os,env:process.env.NODE_ENV}));
        // } catch (err) {
        //   console.log("Analytics tracking error:", err);
        //   // Silent fail, analytics error should never block app usage.
        // }
        if (!!_web) {
          if (viewObj.viewKey === "home") {
            viewPath = "";    // Don`t put `/home`, just `/` below.
          }
          if (viewObj.viewKey != "logout" && !!_web && history.state?.viewPath !== viewPath) {
            // Don't put `/logout` in URL, so that re-login returns to same page prior to logout.
            if (viewPath[0] !== "/") {
              viewPath = "/"+viewPath;
            }
            history.pushState({viewPath:viewObj.validPath}, null, viewObj.validPath);
          }
        }

        screenStateRef.current.currentView = viewObj.viewKey;
        screenStateRef.current.currentViewPath = viewObj.validPath;
        screenStateRef.current.currentViewParams = viewObj.viewParams;
      }
    };
    // Process any stack items from current page components
    let onConfirmLeave = ()=>{};  // default empty function.
    if (!!window.main.onUnsavedFormStack && typeof(window.main.onUnsavedFormStack) === "object" && Object.keys(window.main.onUnsavedFormStack).length > 0) {
      for (const [key, func] of Object.entries(window.main.onUnsavedFormStack)) {
        if (typeof(func)==="function") {
          allowLeave = func();
        } else {
          if (Array.isArray(func) && typeof(func[1])==="function") {
            onConfirmLeave = func[1];
          }
          if (Array.isArray(func) && typeof(func[0])==="function") {
            allowLeave = func[0]();
          }
        }
      }
    }
    if (!allowLeave) {
      triggerAlert({
        show: true,
        title: "Editing Form!",
        message: "If you leave your edits will not be saved.",
        closeOnTouchOutside: true,
        closeOnHardwareBackPress: true,
        showCancelButton: true,
        cancelButtonColor: window.main.theme.colors.success,
        cancelText: "Stay",
        onCancelPressed: () => {
          triggerAlert();
        },
        showConfirmButton: true,
        confirmButtonColor: window.main.theme.colors.caution,
        confirmText: "Leave",
        onConfirmPressed: () => {
          continueExec();
          onConfirmLeave();
          triggerAlert();
        },
      });
      return false;
    }
    continueExec();
    return true;
  };
  window.main.lib.setCurrentView = (viewPath) => {
    const viewObj = getDefaultViewObj(viewPath);  // Return object: { currentView: "string", currentViewParams: (nested-object key-num pairs) -> { name1: 1, name2: 2 } };
    let allowLeave = true;
    if (viewObj.validPath!==window.main.lib.getCurrentViewPath()) {
      allowLeave = window.main.lib.setTempCurrentView(viewObj); // This set `screenStateRef.current.currentView`...
    }
    if (!allowLeave) {
      return false;
    }
    const viewDetails = appviews[viewObj.viewKey];
    //               ⌄⌄⌄ This is in /helpers/auth.js
    window.main.auth.checkSession(false, false);
    if (viewDetails.hasOwnProperty("function")) {
      viewDetails.function(viewObj.viewParams);
    } else {
      _setViewState();
    }
  };
  window.main.lib.getCurrentViewPath = () => { return _screenState.currentViewPath };
  window.main.lib.getCurrentViewParams = () => { return _screenState.currentViewParams };
  window.main.lib.setTempCurrentViewParams = (obj) => {
    if (!obj || typeof(obj)!=="object") {
      return;
    }
    let validObj = {};
    Object.entries(obj).forEach(([key,val]) => { if (!!Number(val)) { validObj[key] = Number(val); }});
    screenStateRef.current.currentViewParams = {..._screenState.currentViewParams, ...validObj}
    // Recreate `validPath`
    let validPath = ["", _screenState.currentView];
    Object.entries(_screenState.currentViewParams).forEach((pair) => validPath.push(pair.join("/")));
    validPath = validPath.join("/");
    // If web, update URL history:
    if (!!_web) {
      history.pushState({viewPath: validPath}, null, validPath);
    }
  };

  window.main.lib.getIsLoggedin           = () => { return _screenState.isLoggedin; };
  window.main.lib.setTempIsLoggedin       = (tf) => { screenStateRef.current.isLoggedin = tf; };
  window.main.lib.setIsLoggedin           = (tf) => { screenStateRef.current.isLoggedin = tf; _setViewState(); };

  window.main.lib.getIsSessionChecked     = () => { return _screenState.isSessionChecked; };
  window.main.lib.setTempIsSessionChecked = (tf) => { screenStateRef.current.isSessionChecked = tf; };
  window.main.lib.setIsSessionChecked     = (tf) => { screenStateRef.current.isSessionChecked = tf; _setViewState(); };

  window.main.lib.triggerMainState        = () => { _setViewState(); };

  window.main.lib.screenState             = _screenState;
  window.main.lib.setScreenState          = _setScreenState;
  window.main.lib.getAppState             = () => { return appState; };
  window.main.lib.setAppState             = (arr) => {
                                              appSetState(arr);
                                            };
  window.main.lib.getLoadingState         = () => { return appState.isScreenLoading; };
  window.main.lib.setLoadingState         = (tf) => {
                                              appSetState([{key:"isScreenLoading", type:"boolean", isScreenLoading:!!tf}]);
                                            };
  window.main.lib.getStatusState          = () => { return appState.statusText; };
  window.main.lib.setStatusState          = (str) => {
                                              appSetState([{key:"statusText", type:"string", statusText:str}]);
                                            };
  window.main.lib.getUserProfile          = () => { return appState.user; };
  window.main.lib.setUserProfile          = (profileObj) => {
                                              appSetState([{key:"user", type:"object", user:profileObj}]);
                                            };
  window.main.lib.getSessionCookie        = () => { return (!!_web?_session.current:""); };

  // Additional library methods
  window.main.lib.getDefaultViewObj       = getDefaultViewObj;
  window.main.lib.getAllWebUrlParams      = getAllWebUrlParams;
  window.main.lib.getWebUrlParam          = getWebUrlParam;
  window.main.lib.getWebUrlQueryParamKey  = getWebUrlQueryParam;
  window.main.lib.getAllWebUrlQueryParams = getAllWebUrlQueryParams;
  window.main.lib.checkResponsive         = checkResponsive;

  window.main.lib.webDomain               = ()=>(!!_web ? window.location.origin : "https://pet.vetmanaged.com");

  window.main.lib.isDate                  = isDate;
  window.main.lib.addDays                 = addDays;
  window.main.lib.dateFormat              = (dateStr)=>{
                                              if (dateStr.length<=10) {
                                                dateStr = dateStr + " 00:00:00";  // When missing timestamp the new Date() function subtracts the current user offset from zero pushing the date that many hours into the prior date, making it display incorretly.
                                              }
                                              return new Date(dateStr).toLocaleDateString("en-us", { month:"short", day:"numeric", year:"numeric"});
                                            };  // weekday:"long",
  window.main.lib.timeFormat              = (dateStr)=>{
                                              if (dateStr.length<=10) {
                                                dateStr = dateStr + " 00:00:00";  // When missing timestamp the new Date() function subtracts the current user offset from zero pushing the date that many hours into the prior date, making it display incorretly.
                                              }
                                              return new Date(dateStr).toLocaleTimeString().replace(/:\d\d\s/,"").toLowerCase();  // Drop time seconds
                                            };
  window.main.lib.datetimeFormat          = (dateStr)=>{
                                              if (dateStr.length<=10) {
                                                dateStr = dateStr + " 00:00:00";  // When missing timestamp the new Date() function subtracts the current user offset from zero pushing the date that many hours into the prior date, making it display incorretly.
                                              }
                                              (window.main.lib.dateFormat(dateStr) + " " + window.main.lib.timeFormat(dateStr)).trim();
                                            };
  window.main.lib.dateRangeDuration       = (start,end)=>{
                                              const startDate = (Number(new Date(start)) ? new Date(start) : null);
                                              const endDate = (Number(new Date(end)) ? new Date(end) : null);
                                              const result = {
                                                days: 0,
                                                hours: 0,
                                                minutes: 0,
                                                seconds: 0,
                                              };
                                              if (!startDate || !endDate) {
                                                return result;
                                              }
                                              // https://stackoverflow.com/a/13904120
                                              let delta = (Math.abs(endDate - startDate) / 1000);
                                              // calculate (and subtract) whole days
                                              result.days = Math.floor(delta / 86400);
                                              delta -= result.days * 86400;
                                              // calculate (and subtract) whole hours
                                              result.hours = Math.floor(delta / 3600) % 24;
                                              delta -= result.hours * 3600;
                                              // calculate (and subtract) whole minutes
                                              result.minutes = Math.floor(delta / 60) % 60;
                                              delta -= result.minutes * 60;
                                              // what's left is seconds
                                              result.seconds = delta % 60;  // in theory the modulus is not required
                                              return result;
                                            };
  window.main.lib.dateRangeDurationTime  = (start,end)=>{
                                              let durStr = "";
                                              if (!!Number(new Date(start))
                                                && !!Number(new Date(end))
                                                && new Date(start).getTime()!==new Date(end).getTime()
                                              ) {
                                                const durObj = window.main.lib.dateRangeDuration(start,end);
                                                durStr = " ("+(!!durObj.days?durObj.days+"D ":"")+durObj.hours+":"+durObj.minutes.toString().padStart(2,"0")+")";
                                              }
                                              return durStr;
                                            };
  window.main.lib.dateRangeDurationStr   = (start,end)=>{
                                              let durStr = "";
                                              if (!!Number(new Date(start))
                                                && !!Number(new Date(end))
                                                && new Date(start).getTime()!==new Date(end).getTime()
                                              ) {
                                                const durObj = window.main.lib.dateRangeDuration(start,end);
                                                durStr = " ("+(!!durObj.days?durObj.days+"D ":"")+(!!durObj.hours?durObj.hours+"H ":"")+durObj.minutes.toString().padStart(2,"0")+"M)";
                                              }
                                              return durStr;
                                            };
  window.main.lib.formatBirthdate         = (dateStr) => {
                                              if (!dateStr) {return "None"};
                                              if (dateStr.length<=10) {
                                                dateStr = dateStr + " 00:00:00";  // When missing timestamp the new Date() function subtracts the current user offset from zero pushing the date that many hours into the prior date, making it display incorretly.
                                              }
                                              const date = new Date(dateStr);
                                              if (isNaN(date)) {return "None"};
                                              const formattedDate = format(date, "MM/dd/yyyy");
                                              const relative = formatDistanceToNowStrict(date, { addSuffix: false });
                                              return `${formattedDate} (${relative} old)`;
                                            };
  window.main.lib.isValidEmail = (str) => { return (new RegExp(/^[\w.+-]+@[\w.+-]+\.[\w.+-]+$/)).test(str); };

  window.main.lib.displayFileSize = (v)=>{
    const i = v == 0 ? 0 : Math.floor(Math.log(v) / Math.log(1024));
    return (v / Math.pow(1024, i)).toFixed(1) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
  };

  window.main.lib.parseErrorMessage = (err,default_message)=>{
    let errMsg = null;
    if (typeof(err)==="object") {
      if (!errMsg && ("response" in err) && typeof(err.response==="object") && ("data" in err.response) && !!err.response?.data) {
        if ("data" in err.response) {
          if (typeof(err.response.data)==="object") {
            if ("error" in err.response.data) {
              errMsg = err.response.data.error;
              if ("missingParams" in err.response.data) {
                errMsg = errMsg + " (" + err.response.data.missingParams + ")";
              }
            } else if ("message" in err.response.data) {
              errMsg = err.response.data.message;
            }
          } else if (typeof(err.response.data)==="string") {
            errMsg = err.response.data;
          }
        } else if ("error" in err.response) {
          errMsg = err.response.error;
        } else if (typeof(err.response)==="string") {
          errMsg = err.response.error;
        }
      }
      if (!errMsg && ("AxiosError" in err)) {
        errMsg = err.AxiosError;
      }
      if (!errMsg && ("request" in err) && ("responseText" in err.request)) {
        errMsg = err.request.responseText;
        if (errMsg.length > 2 && errMsg[0]==="{" && errMsg[errMsg.length-1]==="}") {
          errMsg = JSON.parse(err.request.responseText);
          if (typeof(errMsg)==="object" && "error" in errMsg) {
            errMsg = errMsg.error;
          }
        }
      }
      if (!errMsg && ("message" in err)) {
        errMsg = err.message;
      }
    } else if (!errMsg && typeof(err)==="string") {
      // This is when 'new Error("_string_")'.
      errMsg = err;
    } else {
      // Count not be parsed.
      errMsg = (default_message||"An error occurred. Please try again.");
    }
    // errMsg should be a string at this point:
    if (errMsg.toLowerCase().includes("sqlstate")) {
      errMsg = "There was a problem processing your request. Please try again. (DB)";
    }
    if (errMsg.toLowerCase().includes("timeout")) {
      errMsg = "The request timed-out. Please try again.";
    }
    return errMsg;
  };


  // // Load global theme styles
  window.main.theme = theme(window.main, checkResponsive(), Dimensions.get("window"), _screenState.currentDarkTheme);

  window.main.theme.boxShadowStyle = (!!_web ? { boxShadow: "0 2px 8px #00000033" } : {shadowColor:"#000000",shadowOpacity:0.1,shadowRadius:12,elevation:2});


  // Event Listener for window/orientation changes.
  const onlayout = ()=>{
    if (!!window.main.dimsCheckTimeout) {
      window.clearTimeout(window.main.dimsCheckTimeout);
      window.main.dimsCheckTimeout = null;
    }
    window.main.dimsCheckTimeout = window.setTimeout(()=>{
      // Process any stack items from current page components
      if (!!window.main.onResizeStack && typeof(window.main.onResizeStack) === "object" && Object.keys(window.main.onResizeStack).length > 0) {
        for (const [key, func] of Object.entries(window.main.onResizeStack)) {
          if (typeof(func)==="function") {
            func();
          }
        }
      }
    }, 10);
  };

  // Event Listener for main content body on-scroll.
  // This is _not_ the same for WEB & MOBILE -->  WEB: Attached to `window` `in userEffect`;  Mobile: Attached to MainBody `ScrollView`;
  const onClickMainBody = (e)=>{
    // Run once, set timeout to check for scroll stop...
    if (!!window.main.onClickStack && typeof(window.main.onClickStack) === "object" && Object.keys(window.main.onClickStack).length > 0) {
      for (const [key, func] of Object.entries(window.main.onClickStack)) {
        if (typeof(func)==="function") {
          func();
        }
      }
    }
  };

  // Event Listener for main content body on-scroll.
  // This is _not_ the same for WEB & MOBILE -->  WEB: Attached to `window` `in userEffect`;  Mobile: Attached to MainBody `ScrollView`;
  const onScrollMainBody = (e)=>{
    if (!!_web) {
      window.main.scrollPosition = { x: window.scrollX, y: window.scrollY };
    } else {
      window.main.scrollPosition = e.nativeEvent.contentOffset;
    }
    if (!window.main.hasOwnProperty("onscrollTimeout")) {
      // Run once, set timeout to check for scroll stop...
      if (!!window.main.onScrollStack && typeof(window.main.onScrollStack) === "object" && Object.keys(window.main.onScrollStack).length > 0) {
        for (const [key, func] of Object.entries(window.main.onScrollStack)) {
          if (typeof(func)==="function") {
            func();
          }
        }
      }
      // window.main.onscrollTimeoutLastPosition = window.main.scrollPosition;
      // window.main.dimsCheckTimeout = window.setTimeout(()=>{
      // if (!!window.main.onscrollTimeout) {
      //   window.clearTimeout(window.main.onscrollTimeout);
      //   window.main.onscrollTimeout = null;
      // }
    }
  };

  // // Trigger only once on initial load:
  const alertModalProxyRootId = useRef(null);  // Used to track rootView.set ID on each instance of SuggestInput.
  useEffect(()=>{  // Testing this out as `useLayoutEffect` rather than `useEffect`.
    const colorSchemeWatcher = Appearance.addChangeListener(({ colorScheme }) => {
      // _setScreenState({ currentDarkTheme: !window.main.lib.screenState.currentDarkTheme });
      _setScreenState({ currentDarkTheme: (colorScheme==="dark") });
      window.main.theme = theme(window.main, checkResponsive(), Dimensions.get("window"), _screenState.currentDarkTheme);
    });
    const func = async ()=>{
      if (!!_web) {
        window.onpopstate = () => {
          if (!!history.state?.viewPath) {
            window.main.lib.setCurrentView(history.state.viewPath);
          }
        };
        window.addEventListener("scroll", onScrollMainBody);
      }
      if (!alertModalProxyRootId.current) {
        alertModalProxyRootId.current = rootView.set(<AlertModal key="baseAlertModal" />);
      }
      // ⬇ LOGGEDIN?? ⬇ This is in /helpers/auth.js
      window.main.auth.checkSession(true, true);
    };
    func();
    // On un-mount closure:
    return ()=>{
      colorSchemeWatcher.remove();
      if (!!_web) {
        window.removeEventListener("scroll", onScrollMainBody);
      }
      rootView.remove(alertModalProxyRootId.current);
    };
  },[]);  // This is triggered only once on initial load.


  // OVERRIDES:
  // If the target VIEW is private, and not-loggedin && is-subscriber (Or is-loggedin and not-subscriber), then override to show login screen without changing the target view nor web url.
  let CurrentViewDetails = appviews[_screenState.currentView];
  if (!!CurrentViewDetails.private && !_screenState.isLoggedin && !!_screenState.isSessionChecked) {
    CurrentViewDetails = appviews[appviews.publicKeys[0]];  // Default Login page override
  } else if (CurrentViewDetails.title==="Log In" && !!_screenState.isLoggedin && !!_screenState.isSessionChecked) {
    CurrentViewDetails = appviews[appviews.keys[1]];  // Default Home page override
  }
  // // If system has active downtime.
  // if (window.main.lib.getCurrentViewPath()!=="/downtime" && !!_cookie.hasOwnProperty(window.main.auth.cookieName)) {
  //   const sessionObj = JSON.parse(_cookie[window.main.auth.cookieName]);
  //   if (!!sessionObj && !!sessionObj.hasOwnProperty("flags") && Array.isArray(sessionObj.flags) && !!sessionObj.flags.length && sessionObj.flags.findIndex((o)=>{return o.flag_key==="downtime";})>-1) {
  //     // window.main.lib.setTempCurrentView("/downtime");
  //     CurrentViewDetails = appviews.downtime;
  //   }
  // }


  const _theme = window.main.theme;
  const styles = {
    scrollView: {
      flexBasis: "100%",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 1,
      width: "100%",
    },
    scrollViewContent: {
      alignItems: "stretch",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: "100%",
    },
    mainBodyInner: {
      alignItems: "stretch",
      cursor: "auto",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "flex-start",
      minHeight: (!!_web?"calc(100vh - 60px)":(Dimensions.get("window").height - statusBarHeight - (_ios?150:102))),  // The full calc breaks this: calc(100vh - (100vh - 100%) - 62px); No explanation why.
      justifyContent:"space-between",
    },

    appLoadingOverlay: {
      alignItems: "center",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      bottom: 0,
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: 0,
      top: 100,
      zIndex: 9998,
    },
    appLoadingContainer: {
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: 200,
      zIndex: 9999,
    },

    bodyOuter: {
      display:"flex",
      alignItems: "center",
      alignSelf: "center",
      backgroundColor: _theme.colors.mode.containerBackgroundColor3, //changed main background in them_colors.js
      cursor: "auto",
      flexBasis: "100%",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "center",
      pointerEvents: "auto",
      position: "relative",
      maxWidth: "auto", //1400 constricts accual width of large screens
      width: (!!_web?"calc(100vw - (100vw - 100%))":(Dimensions.get("window").width)),
      // ^ While this appears to be equal to '100%' it's not the case in some browsers when SCROLLBARS are visible. -> https://stackoverflow.com/a/34884924
    },

    bodyInner: {
      alignItems: "center",
      alignSelf: "center",
      backgroundColor: _theme.colors.mode.containerBackgroundColor3, //changed main background in them_colors.js
      cursor: "auto",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "center",
      maxWidth: 1400,
      pointerEvents: "auto",
      position: "static",
      width: "100%",
    },

  };

  return (
    <View id="rootBody" style={styles.bodyOuter} onClick={onClickMainBody}>
      <View id="rootBodyInner" style={styles.bodyInner} >
      {/* <View id="rootBody" style={styles.bodyOuter}> */}
        {!!_screenState.isLoggedin &&
          <Header />
        }
        {!!appState.statusText &&
          <DisplayStatus textState={appState.statusText} setTextState={window.main.lib.setStatusState} style={{position:"fixed",top:100}} />
        }
        <ScrollView id="ScrollView" onLayout={onlayout} onScroll={onScrollMainBody} bounces={false} scrollsToTop={false} keyboardShouldPersistTaps="always" scrollEventThrottle={1} style={styles.scrollView} contentContainerStyle={styles.scrollViewContent}>
          <View id="mainBody" style={styles.mainBodyInner}>
              {!!appState.initReady && !!_screenState.isSessionChecked && <CurrentViewDetails.view />}
              {/* <CurrentViewDetails.view userProfileState={appState.user} /> */}
              {/* <CurrentViewDetails.view /> */}
          </View>
        </ScrollView>
        {/* <Footer /> */}
        <ScreenLoading loadingState={appState.isScreenLoading} style={{paddingTop:100}} />
      </View>
    </View>
  );

};





/////////////////////////////////////
// Helpers
/////////////////////////////////////

const getViewNameFromKey = (viewKey) => {
  viewKey = viewKey?.toLowerCase().replace(/^\/+|\/+$/g, "");  // again, just in case it was called outside of getDefaultViewObj().
  if (!!viewKey && appviews.keys.includes(viewKey)) {
    return viewKey;
  }
  return appviews.keys[0];
};

const getDefaultViewObj = (viewUrl) => {
  if (!viewUrl && window.main.platform_os==="web") {
    viewUrl = window.location.pathname.toLowerCase().replace(/^\/+|\/+$/g, "");  // Lowercase and removed beginning & end slashes
  }
  if (!!viewUrl && typeof(viewUrl)==="string") {
    let urlViewName = (viewUrl.match(/([a-z_]+)/g)||["home"])[0].replace(/^\/+|\/+$/g, "").replace(/\//g, "_");  // NOTE: match on "/" defaults to "home".
    let validViewKey = getViewNameFromKey(urlViewName);
    if (validViewKey === "logout") {
      validViewKey = appviews.keys[0];
    } // tried commented out above 3 lines to get logout to work but causes error
    let viewParams = {};
    const urlParamsPath = viewUrl.replace((validViewKey+"/"),"");
    urlParamsPath.match(/([^\/]+\/([^\/]+))/g)?.forEach((str)=>{
      let a = str.split("/");
      viewParams[a[0]] = (!isNaN((a[1])) ? Number(a[1]) : a[1]);
    });
    const urlQueryParams = viewUrl.split("?")[1];
    // Recreate `validPath`
    let validPath = [validViewKey];
    Object.entries(viewParams).forEach((pair) => validPath.push(pair.join("/")));
    validPath = "/" + validPath.join("/") + (urlQueryParams?"?"+urlQueryParams:"");
    let returnViewObj = {
      viewKey: validViewKey,
      validPath: validPath,
      viewParams: viewParams,
    };
    return returnViewObj;
  }
  return {
    viewKey: appviews.keys[0],
    validPath: "/" + appviews.keys[0],
    viewParams: {}
  };
};

const getAllWebUrlParams = () => {
  if (window.main.platform_os!=="web") {
    return null;
  }
  return window.location.pathname.replace(/^\/+|\/+$/g,"").split("/").splice(1);
};

const getWebUrlParam = (key) => {
  if (window.main.platform_os!=="web") {
    return null;
  }
  const viewUrl = window.location.pathname.toLowerCase().replace(/^\/+|\/+$/g, "");  // Lowercase and removed beginning & end slashes
  if (!viewUrl || typeof(viewUrl)!=="string") {
    return null;
  }
  const matchObj = viewUrl.match(new RegExp(`${key}+\/[^\/]+`));
  if (!matchObj || !matchObj.length) {
    return null;
  }
  return matchObj[0].replace(`${key}/`,"");
};

const getAllWebUrlQueryParams = () => {
  if (window.main.platform_os!=="web") {
    return {};
  }
  if (!window.location.search) {
    return {};
  }
  // return location.search.substring(1,).split("&").map((s)=>{const a=s.split("="); return {key:a[0],value:a[1]}; });
  // ^ Don't return an array, instead return a single 'object' with all key-value pairs.
  const searchArray = window.location.search.substring(1,).split("&");
  const qp = {};
  if (!!searchArray.length) {
    searchArray.forEach((s)=>{
      const kv = s.split("=");
      qp[kv[0]] = kv[1];
    });
  }
  return qp;
};

const getWebUrlQueryParam = (key) => {
  const allParams = getAllWebUrlQueryParams();
  if (!!allParams && typeof(allParams)==="object" && allParams.hasOwnProperty(key)) {
    return allParams[key];
  }
  return null;
};

// Determine responsive screen width
// https://medium.com/miquido/how-to-create-responsive-layouts-in-react-native-7c4cfa15f1de
// https://stackoverflow.com/questions/47683591/react-native-different-styles-applied-on-orientation-change
const checkResponsive = () => {  // Returns key one of ["large","medium","small"]
  const flexBreakpoint = 1400;
  const mobileBreakpoint = 926;  // https://www.icwebdesign.co.uk/common-viewport-sizes  iPhone Pro Max
  let respKey = "large";  // default
  if (Dimensions.get("window").width <= mobileBreakpoint) {
    respKey = "phone";
  } else if (Dimensions.get("window").width <= flexBreakpoint) {
    respKey = "medium";
  }
  return respKey;
};

export default Main;
